import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { auctionFlags, resolveFlag, auctionAudit, money, errText } from "@/lib/bidCenterApi";

const KIND = { deleted_accepted_bid: "Accepted bid deleted on Facebook", edited_accepted_bid: "Accepted bid edited (original amount stays binding)",
  changed_after_completion: "Changed after the auction was completed" };

function FlagRow({ f, onDone }) {
  const resolve = async () => {
    try { await resolveFlag(f.id, "Reviewed in Bid Management"); toast.success("Flag resolved"); onDone(); } catch (e) { toast.error(errText(e)); }
  };
  return (
    <li data-testid={`auction-flag-${f.id}`} className="rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm">
      <p className="font-medium text-amber-900">{KIND[f.kind] || f.kind}{f.after_completion ? " — after completion" : ""}</p>
      <p className="text-stone-700">{f.author_name}: “{f.text}” {f.amount != null && `(${money(f.amount)})`}</p>
      {f.warning_draft && <p data-testid="flag-warning-draft" className="mt-1 text-xs text-stone-600">Draft group warning (not posted, needs separate approval): {f.warning_draft}</p>}
      {f.status === "open"
        ? <Button data-testid={`resolve-flag-${f.id}`} size="sm" variant="outline" className="mt-2 rounded-full" onClick={resolve}>Mark reviewed</Button>
        : <p className="mt-1 text-xs text-stone-500">Resolved by {f.resolved_by}</p>}
    </li>
  );
}

export function AuctionFlags({ a }) {
  const [flags, setFlags] = useState([]);
  const [chain, setChain] = useState(null);
  const load = () => {
    auctionFlags(a.post_id).then((r) => setFlags(r.flags)).catch(() => {});
    auctionAudit(a.post_id).then((r) => setChain(r.chain)).catch(() => {});
  };
  useEffect(() => { load(); }, [a.post_id]); // eslint-disable-line react-hooks/exhaustive-deps
  const fin = a.final_result;
  const cur = fin && (fin.corrections?.length ? fin.corrections[fin.corrections.length - 1].to : fin.winner);
  return (
    <section data-testid="auction-flags" className="mt-4 space-y-2">
      {fin && <p data-testid="final-result" className="text-sm text-stone-800">Result: {cur ? `${cur.bidder} ${money(cur.amount)}` : "no valid winner"}
        {fin.corrections?.length ? ` · corrected by admin (original: ${fin.winner ? `${fin.winner.bidder} ${money(fin.winner.amount)}` : "no valid bid"})` : ""}</p>}
      {chain && <p data-testid="audit-chain" className="text-xs text-stone-500">Audit log: {chain.ok ? `${chain.entries} entries, intact` : `TAMPERING DETECTED at entry ${chain.broken_at}`}</p>}
      {flags.length > 0 && <ul className="space-y-2">{flags.map((f) => <FlagRow key={f.id} f={f} onDone={load} />)}</ul>}
    </section>
  );
}
